"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _uid = require("../utils/uid");

var _types = require("../Datum/types");

var _context = require("../Checkbox/context");

var _styles = require("../styles");

var _Radio = _interopRequireDefault(require("./Radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var RadioGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(RadioGroup, _PureComponent);

  function RadioGroup(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleRawChange = _this.handleRawChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    this.props.datum.subscribe(_types.CHANGE_TOPIC, this.handleUpdate);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.props.datum.unsubscribe(_types.CHANGE_TOPIC, this.handleUpdate);
  };

  _proto.getContent = function getContent(d) {
    var renderItem = this.props.renderItem;

    if (typeof renderItem === 'string') {
      return d[renderItem];
    }

    if (typeof renderItem === 'function') {
      return renderItem(d);
    }

    return '';
  };

  _proto.handleClick = function handleClick(val, checked, index) {
    var _this$props = this.props,
        data = _this$props.data,
        datum = _this$props.datum;
    datum.set(data[index]);
  };

  _proto.handleRawChange = function handleRawChange(value) {
    this.props.datum.set(value);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        block = _this$props2.block,
        data = _this$props2.data,
        datum = _this$props2.datum,
        keygen = _this$props2.keygen,
        children = _this$props2.children;
    var className = (0, _classnames.default)((0, _styles.checkinputClass)('group', block && 'block'), this.props.className);

    if (data === undefined) {
      return _react.default.createElement("div", {
        className: className
      }, _react.default.createElement(_context.Provider, {
        value: {
          onRawChange: this.handleRawChange,
          checked: datum.check.bind(datum)
        }
      }, children));
    }

    return _react.default.createElement("div", {
      className: className
    }, data.map(function (d, i) {
      return _react.default.createElement(_Radio.default, {
        checked: datum.check(d),
        disabled: datum.disabled(d),
        key: (0, _uid.getKey)(d, keygen, i),
        htmlValue: i,
        index: i,
        onChange: _this2.handleClick
      }, _this2.getContent(d));
    }), children);
  };

  return RadioGroup;
}(_component.PureComponent);

RadioGroup.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'children', 'keygen'), {
  block: _propTypes.default.bool,
  data: _propTypes.default.array,
  datum: _propTypes.default.object.isRequired,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
});
RadioGroup.defaultProps = {
  renderItem: function renderItem(d) {
    return d;
  }
};
var _default = RadioGroup;
exports.default = _default;